import {
    Box as UiBox,
    SwipeableDrawer as UiSwipeableDrawer,
    styled,
} from "@mui/material"

const PULLER_HEIGHT = 4
const PULLER_WIDTH = 32

export const SwipeableDrawer = styled(UiSwipeableDrawer)(({ theme }) => ({
    "& > .MuiPaper-root": {
        borderRadius: theme.spacing(7, 7, 0, 0),
        maxHeight: `calc(100% - ${theme.spacing(5)})`,
    },
}))

export const Box = styled(UiBox)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(4, 0, 6, 0),
    position: "relative",
}))

export const Puller = styled("div")(({ theme }) => ({
    alignItems: "center",
    backgroundColor: theme.palette["action/disabled"].main,
    borderRadius: theme.spacing(1),
    height: PULLER_HEIGHT,
    justifyContent: "center",
    position: "relative",
    width: PULLER_WIDTH,
}))

export const PullerContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    marginBottom: theme.spacing(4),
    justifyContent: "center",
    width: "100%",
}))